var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeart06 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  stroke: "#333",
  strokeLinecap: "square",
  strokeWidth: 1.067,
  d: "M13.075 3.592a3.16 3.16 0 0 0-4.467 0L8 4.201l-.609-.609a3.158 3.158 0 0 0-4.466 4.466l.609.609L8 13.133l4.466-4.466.609-.609a3.16 3.16 0 0 0 0-4.466Z"
})));
export default SvgIconHeart06;